import { SET_WORK } from "../actions/work";

const INITIAL_STATE = {
  work: {},
};

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_WORK:
      return {
        ...state,
        work: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
